import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function HomeCta() {
  return (
    <section className="relative py-24 bg-[#D4AF37] overflow-hidden" data-testid="home-cta">
      <div className="absolute inset-0 home-grid-dark opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-black max-w-3xl leading-tight">Il rischio che conosci è un rischio che puoi gestire.</h2>
        <a href="/subscribe" className="shrink-0 h-12 px-7 rounded-full bg-black hover:bg-[#1A1A1A] text-[#D4AF37] font-semibold inline-flex items-center gap-2 transition-colors self-start lg:self-auto" data-testid="home-cta-bottom">Richiedi accesso<ArrowRight size={18} /></a>
      </div>
    </section>
  );
}
